export const processSteps = [
  {
    title: { en: 'Free Consultation', es: 'Consulta Gratuita' },
    description: {
      en: "Contact us to discuss your project needs. We'll answer all your questions and provide guidance.",
      es: 'Contáctanos para discutir las necesidades de tu proyecto. Responderemos todas tus preguntas y proporcionaremos orientación.',
    },
  },
  {
    title: { en: 'Site Inspection & Estimate', es: 'Inspección y Estimado' },
    description: {
      en: 'Our team visits your property, assesses the work, and provides a detailed free estimate—no obligation.',
      es: 'Nuestro equipo visita tu propiedad, evalúa el trabajo y proporciona un estimado gratuito detallado, sin obligación.',
    },
  },
  {
    title: { en: 'Project Planning', es: 'Planificación del Proyecto' },
    description: {
      en: 'Once you approve, we schedule the work and coordinate all details for a smooth project execution.',
      es: 'Una vez que apruebes, programamos el trabajo y coordinamos todos los detalles para una ejecución fluida del proyecto.',
    },
  },
  {
    title: { en: 'Expert Execution', es: 'Ejecución Experta' },
    description: {
      en: 'Our experienced crew completes your project with precision and professionalism.',
      es: 'Nuestro equipo experimentado completa tu proyecto con precisión y profesionalismo.',
    },
  },
  {
    title: { en: 'Quality Inspection', es: 'Inspección de Calidad' },
    description: {
      en: 'We inspect every detail to ensure the work meets our high quality standards.',
      es: 'Inspeccionamos cada detalle para asegurar que el trabajo cumpla con nuestros altos estándares de calidad.',
    },
  },
  {
    title: { en: 'Customer Satisfaction', es: 'Satisfacción del Cliente' },
    description: {
      en: 'You get premium results and exceptional service every time.',
      es: 'Obtienes resultados premium y servicio excepcional cada vez.',
    },
  },
];
